import React from 'react';
import { Container } from '@fiverr-private/layout_components';
import {
  FOOTER_COPYRIGHT,
  FOOTER_PRIVACY_TEXT,
  FOOTER_PRIVACY_URL,
  FOOTER_TERMS_TEXT,
  FOOTER_TERMS_URL,
} from './constants';
import { section, footerText, footerLink } from './styles.ve.css';

const FooterSection: React.FC = () => (
  <Container as="footer" className={section}>
    <p className={footerText}>{FOOTER_COPYRIGHT}</p>
    <a href={FOOTER_PRIVACY_URL} className={footerLink} target="_blank" rel="noopener noreferrer">
      {FOOTER_PRIVACY_TEXT}
    </a>
    <a href={FOOTER_TERMS_URL} className={footerLink} target="_blank" rel="noopener noreferrer">
      {FOOTER_TERMS_TEXT}
    </a>
  </Container>
);

export default FooterSection;
